import MeasureUnit from '../MeasureUnit';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { USER_HEALTH_CARD } from '../UserInfo/UserData';
import { useState } from 'react';
import { useAppContext } from '../../Services/AppContext';
import Loading from '../Loading';

export default function PatientProfileHealthCard({
	userId,
	insuranceCardDetailLink,
}) {
	const [healthCard, setHealthCard] = useState(null);
	const { translation } = useAppContext();

	// @ts-ignore
	useEffectAsync(async () => {
		let result;
		if (userId) {
			result = await apiClient.graphql({
				query: USER_HEALTH_CARD,
				variables: { userId },
				fetchPolicy: 'network-only',
			});
		}
		const healthCardData = result?.data?.user?.healthCard || {};
		healthCardData.insuranceCardFrontUrl =
			result?.data?.user?.insuranceCardFrontThumbnailUrl || null;
		healthCardData.insuranceCardBackUrl =
			result?.data?.user?.insuranceCardBackThumbnailUrl || null;

		setHealthCard(healthCardData);
	});

	const hasInsuranceCard =
		healthCard?.insuranceCardFrontUrl || healthCard?.insuranceCardBackUrl;

	return (
		<div className='row'>
			{hasInsuranceCard && (
				<div className='col-12 col-md-6 col-lg-4 pt-3'>
					<strong className='text-primary'>
						{translation['base.shared.insuranceCard']}
					</strong>
					<br />
					{healthCard?.insuranceCardFrontUrl && (
						<div className='mt-3 text-gray font-size-19'>
							<a
								href={insuranceCardDetailLink}
								className='d-block position-relative'
							>
								<img
									src={healthCard.insuranceCardFrontUrl}
									className='img-fluid'
									alt={translation['base.shared.insuranceCard']}
								/>
								<div
									className='btn btn-primary btn-circle'
									style={{
										position: 'absolute',
										right: '-10px',
										botom: '-10px',
										width: '42px',
										height: '42px',
										textAlign: 'center',
										lineHeight: '28px',
									}}
								>
									<i className='fa fa-search-plus'></i>
								</div>
							</a>
						</div>
					)}
					{healthCard?.insuranceCardBackUrl && (
						<div className='mt-3 text-gray font-size-19'>
							<a
								href={insuranceCardDetailLink}
								className='d-block position-relative'
							>
								<img
									src={healthCard.insuranceCardBackUrl}
									className='img-fluid'
									alt={translation['base.shared.insuranceCard']}
								/>
								<div
									className='btn btn-primary btn-circle'
									style={{
										position: 'absolute',
										right: '-10px',
										botom: '-10px',
										width: '42px',
										height: '42px',
										textAlign: 'center',
										lineHeight: '28px',
									}}
								>
									<i className='fa fa-search-plus'></i>
								</div>
							</a>
						</div>
					)}
				</div>
			)}
			<div
				className={
					hasInsuranceCard ? 'col-12 col-md-6 col-lg-4 pt-3' : 'col-12 col-md-6'
				}
			>
				<strong className='text-primary'>
					{translation['base.shared.anamnesticQuestinnaire']}
				</strong>
				<br />
				<div className='mt-3 pb-5 text-gray font-size-19'>
					<span className='font-weight-semibold'>
						{translation['base.shared.form.height.shortLabel']}:
					</span>{' '}
					<MeasureUnit
						number={healthCard?.height}
						measureUnit={translation['base.shared.units.height']}
					/>
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.weight.shortLabel']}:
					</span>{' '}
					<MeasureUnit
						number={healthCard?.weight}
						measureUnit={translation['base.shared.units.weight']}
					/>
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.allergies_medicaments.label']}:
					</span>{' '}
					{healthCard?.allergies}
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.allergies_others.label']}:
					</span>{' '}
					{healthCard?.allergiesOther}
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.operations.label']}:
					</span>{' '}
					{healthCard?.operations}
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.medicaments.shortLabel']}:
					</span>{' '}
					{healthCard?.medicament}
					<br />
					<span className='font-weight-semibold'>
						{translation['base.shared.form.sickness.label']}:
					</span>{' '}
					{healthCard?.sickness}
				</div>
			</div>
			<div
				className={
					hasInsuranceCard ? 'col-12 col-md-6 col-lg-4 pt-3' : 'col-12 col-md-6'
				}
			>
				<strong className='text-primary'>
					{translation['base.shared.familyHistory']}
				</strong>
				<br />
				<div className='mt-3 text-gray font-size-19'>
					{healthCard?.anamnesisFamily}
				</div>
			</div>
		</div>
	);
}
